import { useEffect, useRef, useCallback } from 'react';

/**
 * Hook para gerenciar sons da roda (tick e celebration)
 */
export const useWheelAudio = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const celebrationAudioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    audioRef.current = new Audio('/tick.mp3');
    celebrationAudioRef.current = new Audio('/celebration.mp3');
    
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
      if (celebrationAudioRef.current) {
        celebrationAudioRef.current.pause();
        celebrationAudioRef.current = null;
      }
    };
  }, []);

  const playTickSound = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(err => console.log('Erro ao tocar som:', err));
    }
  }, []);

  const playCelebrationSound = useCallback(() => {
    if (celebrationAudioRef.current) {
      celebrationAudioRef.current.volume = 1;
      celebrationAudioRef.current.play().catch(err => console.log('Erro ao tocar celebration:', err));
    }
  }, []);

  return { playTickSound, playCelebrationSound };
};
